<template>
  <div>
    <v-btn @click="startDeliveryExport" :width="$vuetify.breakpoint.xs ? 115 : 150" color="primary" class="light--text text-capitalize text-end me-2 me-sm-3" :small="$vuetify.breakpoint.xs">
      <v-icon :small="$vuetify.breakpoint.xs" class="me-1">mdi-file-document</v-icon>Meal Sticker
    </v-btn>
    <v-snackbar v-model="exportStarted" timeout="6000" right top color="success"
      >Export Started
      <router-link :to="{ name: 'ReportStatus' }">click here to view report status</router-link>
    </v-snackbar>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { tz } from "moment-timezone";

export default Vue.extend({
  props: {
    reportList: { require: true },
    disabled: { require: true },
    deliveryDate: { require: true },
  },
  created() {},
  watch: {},

  data() {
    return {
      menu: false,
      exportStarted: false,
      tz: tz,
      loading: false,
      expDate: new Date(),
      btnloading: false,
      meanInfos: [],
      mealStickers: [],
    };
  },

  methods: {
    startDeliveryExport() {
      this.exportStarted = true;
      const dateTime = moment(`${this.deliveryDate}`).format("YYYY-MM-DD");
      let modifiedDate = new Date(dateTime);
      this.$apollo
        .watchQuery({
          query: require("@/delivery/api/excelDeliveryExportReport.graphql"),
          variables: {
            status: "",
            type: "SET_MENU_MEAL_STICKER",
            shift: "",
          },
        })
        .refetch({
          variables: {
            status: "",
            date: modifiedDate,
            type: "SET_MENU_MEAL_STICKER",
            shift: "",
          },
        })
        .then(() => {})
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
        });
    },
  },
});
</script>

<style scoped>
.border {
  border: solid 0.1mm black;
  height: 9.525mm;
  width: 14.8mm;
  margin-bottom: 2px;
  font-family: sans-serif;
}
.section {
  position: absolute;
  background-color: black;
  -webkit-print-color-adjust: exact;
  color: white;
  height: 4.5mm;
  width: 14.378mm;

  /* padding: 10; */
}
.section2 {
  margin-top: 4.5mm;
  position: absolute;
  background-color: white;
  -webkit-print-color-adjust: exact;
  color: black;
  height: 4.5mm;
  width: 14.21mm;
}

#item_name {
  margin-top: 1px;
  font-size: 2.2pt;
  text-align: center;
}
.id_item {
  font-size: 2pt;
  text-align: center;
  margin-top: 0.5px;
  overflow: hidden;
  white-space: nowrap;
}
#dis_item {
  margin-top: 0.5px;
  font-size: 2pt;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
}
ul {
  margin: 0;
  padding: 0;
  overflow: hidden;
  color: white !important;
  font-size: 2pt;
  list-style-type: none;
}

li {
  color: black !important;
  float: left;
}
.list_main {
  margin-left: 7px;
  margin-top: 2px;
}
.customer_address {
  text-align: center;
  margin-top: 0.2px;
  font-size: 1.9pt;
  overflow: hidden;
  white-space: nowrap;
}

.list {
  margin-left: 5px;
}

#category {
  font-size: 2.2pt;
  text-align: center;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
}
.menuCategory {
  margin-top: -0.8pt;
  margin-left: 2px;
}
.sep {
  margin-top: 0px;
}

.date {
  font-size: 1.8pt;
  text-align: center;
}

.logo {
  text-align: center;
  position: sticky;
  margin-top: 2.2px;
  bottom: 100%;
}

.print-break-page {
  clear: both;
  page-break-after: always;
}
</style>
